import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { userActions } from '_actions';
import { Loading } from 'components/common';
import { formModes } from '_constants';
import { UserForm } from './UserForm'
import {Box} from "@mui/system";
import {Grid} from "@mui/material";

export default function EditUser() {
    const dispatch = useDispatch();
    const { id } = useParams();
    const { user, loading } = useSelector(state => state.users);

    useEffect(() => {
        dispatch(userActions.getUser(id));
    }, [dispatch, id]);

    const saveClickHandler = (params) => {
        const updatePasswordRequest = { password: params.password };
        delete params.password;
        dispatch(userActions.updateUserByAdmin(params, updatePasswordRequest));
    };

    if (!user || !user.id) {
        return <Loading />;
    }

    return (
        <Box sx={{backgroundColor: '#EFEAE7'}}>
            <Grid container sx={{padding: '120px 50px 50px'}}>
                <UserForm
                    onSave={saveClickHandler}
                    cancelLink={`/users/${user?.id}/show`}
                    user={user}
                    mode={formModes.EDIT}
                    loading={loading}
                />
            </Grid>
        </Box>
    );
};
